module.exports = __webpack_public_path__ + "static/scale-model-of-foss-waterway-seaport-in-tacoma-washington-5d9fd36c484ed4dd147d5b4940fd2279.png";